$('.hero__slider').slick({
    infinite: true,
    arrows: false,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true
});

$('.career-gallery__slider').slick({
    infinite: true,
    arrows: false,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 7,
    dots: false,
    centerMode: true,
      responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 6,
      }
    },
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 5,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      }
    },
  ]
});